import React, { useMemo, useState, useEffect } from 'react'
import { ButtonGroup } from '@ow/comps'
import { Drawer } from '@mantine/core'
import { IconMaps } from '@ow/icons'
import { useWindowSize } from 'react-use'
import styled from '@emotion/styled'

const StyledSort = styled.div`
  > div + div {
    border-top: 1px solid #e7e7e7;
  }
`

const Icon = ({ index, activeSort, activeKey }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <IconMaps
        type="chevronUp"
        fill={
          activeSort === 'asc' && index === activeKey
            ? 'var(--ow-color-primary-700)'
            : 'var(--ow-color-gray-300)'
        }
      />
      <div className="-mt-2">
        <IconMaps
          type="chevronDown"
          fill={
            activeSort === 'desc' && index === activeKey
              ? 'var(--ow-color-primary-700)'
              : 'var(--ow-color-gray-300)'
          }
        />
      </div>
    </div>
  )
}
const Sort = function ({ setSorts, fields }) {
  const [activeKey, setActiveKey] = useState()
  const [activeSort, setActiveSort] = useState()
  const [isOpenDrawer, setOpen] = useState()
  const { width } = useWindowSize()
  const isMiddle = width <= 1200

  useEffect(() => {
    if (fields) {
      const defaultSort = fields.find((f) => f.isDefault)
      if (defaultSort) {
        setActiveKey(defaultSort.slug)
        setActiveSort('desc')
      }
    }
  }, [fields])

  const sortSlug = useMemo(() => {
    return fields
      .filter((f) => f.sortable)
      .map((m) => {
        return {
          ...m,
          key: m,
          label: (
            <div className="flex items-center justify-center">
              <span className="text-gray-200 mr-3">{m.title}</span>
              <Icon
                index={m.slug}
                activeSort={activeSort}
                activeKey={activeKey}
              />
            </div>
          ),
        }
      })
  }, [fields, activeSort, activeKey])

  const changeSort = (e) => {
    let order = 'desc'
    const { slug } = e
    if (slug === activeKey) {
      if (activeSort === 'desc') order = 'asc'
      else order = 'desc'
    }
    setActiveKey(slug)
    setSorts({ slug, order }, true)
    setActiveSort(order)
  }

  const middleChangeSort = (slug, order) => {
    setActiveKey(slug)
    setSorts({ slug, order }, true)
    setActiveSort(order)
    setOpen(false)
  }

  return (
    <div>
      {!isMiddle && (
        <ButtonGroup
          onClick={(e) => {
            changeSort(e)
          }}
          options={sortSlug}
          stroke
          activeType="primary"
          borderColor="var(--ow-color-neutral-400)"
          activeBorderColor="var(--ow-color-primary-400)"
          activeTextColor="var(--ow-color-primary-400)"
          activeKey={activeKey}
          borderRadius={4}
          size={window.screen.width > 768 ? 'md' : 'sm'}
        />
      )}
      {isMiddle && (
        <div
          className="px-4 cursor-pointer"
          onClick={() => {
            setOpen(true)
          }}
        >
          <IconMaps type="sort" width={20} height={20} size={20} fill="dark" />
        </div>
      )}
      <Drawer
        opened={isOpenDrawer}
        onClose={() => setOpen(false)}
        position="bottom"
        styles={{
          drawer: {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          },
          header: {
            display: 'none',
          },
        }}
      >
        <StyledSort className="py-2 overflow-auto">
          {sortSlug.map((item) => {
            return (
              <>
                <div
                  className="p-4 cursor-pointer flex justify-between items-center"
                  onClick={() => {
                    middleChangeSort(item.slug, 'asc')
                  }}
                >
                  <span>{item.title}正序</span>
                  {activeKey === item.slug && activeSort === 'asc' && (
                    <IconMaps type="check" width={20} height={20} fill="blue" />
                  )}
                </div>
                <div
                  className="p-4 cursor-pointer flex justify-between items-center"
                  onClick={() => {
                    middleChangeSort(item.slug, 'desc')
                  }}
                >
                  <span>{item.title}倒序</span>
                  {activeKey === item.slug && activeSort === 'desc' && (
                    <IconMaps type="check" width={20} height={20} fill="blue" />
                  )}
                </div>
              </>
            )
          })}
        </StyledSort>
      </Drawer>
    </div>
  )
}
export default Sort
